import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";
import { formatApiError } from "../lib/api";
import { toast } from "sonner";

export default function Login() {
  const nav = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.name}`);
      nav(u.role === "admin" ? "/admin" : u.role === "buyer" ? "/buyer" : "/fpo");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  const fill = (kind) => {
    if (kind === "fpo") { setEmail("fpo@gudlink.in"); setPassword("Fpo@123"); }
    if (kind === "buyer") { setEmail("buyer@gudlink.in"); setPassword("Buyer@123"); }
    if (kind === "admin") { setEmail("admin@gudlink.in"); setPassword("Admin@123"); }
  };

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid md:grid-cols-2 gap-12 items-center">
      <div className="hidden md:block">
        <div className="text-xs uppercase tracking-[0.28em] text-secondary">Welcome back</div>
        <h1 className="font-marketing text-5xl leading-tight mt-3">
          The Sahyadris kept your record. Come sign in.
        </h1>
        <p className="text-muted-foreground mt-4 max-w-md">Sign in to manage your batches, verify a QR, or oversee the platform.</p>
      </div>

      <form onSubmit={submit} className="bg-card border border-border rounded-2xl p-8 shadow-sm" data-testid="login-form">
        <h2 className="font-heading text-2xl font-semibold">Sign in</h2>
        <p className="text-sm text-muted-foreground mt-1">Enter your credentials to continue.</p>

        <div className="mt-6 space-y-4">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="email"/>
          </div>
          <div>
            <Label htmlFor="password">Password</Label>
            <Input id="password" data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password"/>
          </div>
          {error && <div className="text-sm text-destructive" data-testid="login-error">{error}</div>}
          <Button type="submit" disabled={loading} className="w-full bg-primary hover:bg-primary/90" data-testid="login-submit">
            {loading ? "Signing in…" : "Sign in"}
          </Button>
        </div>

        <div className="mt-6 pt-6 border-t border-border/70 text-xs text-muted-foreground">
          <div className="uppercase tracking-[0.2em] mb-2">Demo credentials</div>
          <div className="flex flex-wrap gap-2">
            <button type="button" onClick={() => fill("fpo")} className="rounded-full border border-border px-3 py-1 hover:bg-muted" data-testid="fill-fpo-btn">FPO</button>
            <button type="button" onClick={() => fill("buyer")} className="rounded-full border border-border px-3 py-1 hover:bg-muted" data-testid="fill-buyer-btn">Buyer</button>
            <button type="button" onClick={() => fill("admin")} className="rounded-full border border-border px-3 py-1 hover:bg-muted" data-testid="fill-admin-btn">Admin</button>
          </div>
        </div>

        <div className="mt-6 text-sm">
          New to Gudlink? <Link to="/register" className="text-primary underline underline-offset-4">Create an account</Link>
        </div>
      </form>
    </div>
  );
}
